/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

export const RECEIVED_CONFIG_FILE = 'RECEIVED_CONFIG_FILE';
export const receivedConfig = (config) => ({
  type: RECEIVED_CONFIG_FILE,
  config
});

export const CONFIG_ERROR = 'ERROR_RETRIEVING_CONFIG';
export const configError = (error) => ({
  type: CONFIG_ERROR,
  error
});

export const REQUESTED_CONFIG = 'REQUESTED_CONFIG_FILE';
export const requestedConfig = () => ({
  type: REQUESTED_CONFIG
});
